<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="dummyData"
      selected-product="cso"
      :product-options="productOptions"
      show-date
      :filter-names="filterNames"
      search-label="search"
      @filterOption="onFiltersChange"
    >
      <!-- <template v-slot:actions="{ item }"> </template> -->

      <template #description>
        <v-row>
          <v-col cols="12">
            <data-completeness-cards
              :loading="isLoading"
              :items="list?.tiles"
            />
          </v-col>
          <v-col cols="12">
            <network-health
              :loading="isLoading"
              :items="list?.locations"
            />
          </v-col>
          <v-col cols="12">
            <div class="font-weight-bold">
              Deployment History
            </div>
          </v-col>
        </v-row>
      </template>

      <!-- add Filters -->
      <!-- <template #addFilters>
        <v-card v-if="authUser.isAdmin">

        </v-card>
      </template> -->
      <!-- add Filters -->
      <template #moreFilters>
        <div>
          <refresh-button
            :is-loading="isLoading"
            @reload="fetchData"
          />
        </div>
      </template>
      <!-- Action Modals -->
      <template #actionModals>
        <div />
      </template>
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    refreshButton: () => import("@/components/base/RefreshButton.vue"),
    DataCompletenessCards: () => import("./utils/DataCompletenessCards.vue"),
    NetworkHealth: () => import("./utils/NetworkHealth.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      productOptions: [
        { id: "oem", value: "OEM" },
        { id: "cso", value: "CSO" },
      ],
      permissions: {
        view: "charge-stations.view",
        create: "charge-stations.create",
        edit: "charge-stations.edit",
        delete: "charge-stations.delete",
      },
      filters: {},
      subFilters: {},

      dummyData: [
        {
          id: 1,
          charge_point_id: "CHG-001",
          tenant_name: "PSO",
          station_name: "Karachi",
          location_name: "1200 / 1180",
          charger_connectors_count: "98%",
        },
        {
          id: 2,
          charge_point_id: "CHG-002",
          tenant_name: "Shell",
          station_name: "Lahore",
          location_name: "1500 / 1450",
          charger_connectors_count: "96.7%",
        },
        {
          id: 3,
          charge_point_id: "CHG-003",
          tenant_name: "Total Parco",
          station_name: "Islamabad",
          location_name: "1000 / 930",
          charger_connectors_count: "93%",
        },
        {
          id: 4,
          charge_point_id: "CHG-004",
          tenant_name: "Attock",
          station_name: "Faisalabad",
          location_name: "800 / 790",
          charger_connectors_count: "98.8%",
        },
        {
          id: 5,
          charge_point_id: "CHG-005",
          tenant_name: "PSO",
          station_name: "Multan",
          location_name: "650 / 620",
          charger_connectors_count: "95.4%",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "dataCompleteness/getLoading",
      meta: "dataCompleteness/getMeta",
      list: "dataCompleteness/getList",
    }),
    _headers() {
      const headers = [
        {
          text: "Charger ID",
          align: "left",
          sortable: false,
          value: "charge_point_id",
        },
        {
          text: this.$t("tenant_name"),
          align: "left",
          sortable: false,
          value: "tenant_name",
          showAdmin: true,
        },
        {
          text: "Location",
          align: "left",
          sortable: false,
          value: "station_name",
        },

        {
          text: "Expected / Received",
          align: "left",
          sortable: false,
          value: "location_name",
        },

        {
          text: "Completeness Score",
          align: "center",
          sortable: false,
          value: "charger_connectors_count",
        },
      ];

      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

    filterNames() {
      return ["search", "locations", "charge_point"];
    },
  },
  watch: {
    options() {
      this.fetchData();
    },
  },
  mounted() {},
  beforeDestroy() {
    const params = {
      name: "data_completeness",
      filters: this.options,
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    async fetchData() {
      const params = { ...this.options };

      await this.$store.dispatch("dataCompleteness/list", params).then(() => {
        if (this.options.page > (this.meta?.lastPage || 1)) {
          this.options.page = 1;
        }
      });
    },
  },
};
</script>
